import AbstractWidget from "@/models/WebsiteWidget/AbstractWidget";
import WebsiteWidget from "@/models/WebsiteWidget/WebsiteWidget";

export default class ContactRequest extends AbstractWidget {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'website-widget/contact-request';

    /**
     *
     * @type {string}
     */
    static entity = 'websiteWidgetContactRequests';

    static model_name = 'ContactRequest';

    static fields() {
		return {
			id: this.attr(null),
			created_at: this.attr(null),
			updated_at: this.attr(null),
            widget: this.hasOne(WebsiteWidget, 'widgetable_id'),
		}
	}

    /**
     *
     * @returns {*}
     * @constructor
     */
    Widget() {
        return WebsiteWidget.byWidgetable(this.WidgetTemplate().key, this.id);
    }
}
